import { render, staticRenderFns } from "./IntegrationIcon.vue?vue&type=template&id=0b2b47d5&scoped=true&"
import script from "./IntegrationIcon.vue?vue&type=script&lang=ts&"
export * from "./IntegrationIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationIcon.vue?vue&type=style&index=0&id=0b2b47d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b47d5",
  null
  
)

export default component.exports